export function filterEmptyValues(obj: Object) {
  return Object.entries(obj)
    .filter(([_, v]) => v !== null && v !== "") // eslint-disable-line no-unused-vars
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})
}
